<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-form @submit.prevent="save">
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="not_muted standardizedWidth"
                      >PO Number</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    class="not_muted"
                    :class="{
                      validate_error: $v.campaign.campaign_edit.PONumber.$error
                    }"
                    v-model="campaign.campaign_edit.PONumber"
                    placeholder="Required"
                    type="text"
                    id="PONumber"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                    @input="$v.campaign.campaign_edit.PONumber.$touch()"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <CoolSelect
                  class="not_muted"
                  v-model="campaign.campaign_edit.DealershipID"
                  placeholder="Dealership"
                  theme="bootstrap"
                  tooltip="Dealership"
                  :items="dealer.dealers"
                  item-text="DropdownDisplay"
                  item-value="DealershipID"
                  id="DealershipID"
                >
                  <template slot="input-before">
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth not_muted"
                        >Dealership</b-input-group-text
                      >
                    </b-input-group-prepend>
                  </template>
                  <!-- <template slot="item" slot-scope="{ item }">
                    <div class="item">
                      <img :src="item.thumbnail" class="logo" />
                      <span class="item-name">{{ item.CommonName }}</span>
                    </div>
                  </template>-->
                </CoolSelect>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <CoolSelect
                  class="not_muted"
                  v-model="campaign.campaign_edit.CampaignTypeID"
                  placeholder="Type"
                  theme="bootstrap"
                  tooltip="Type"
                  :items="campaign.campaign_types"
                  :disabled="campaign.campaign_edit.DealershipID < 1"
                  item-text="Name"
                  item-value="CampaignTypeID"
                  id="CampaignTypeID"
                >
                  <template slot="input-before">
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth not_muted"
                        >Type</b-input-group-text
                      >
                    </b-input-group-prepend>
                  </template>
                  <!-- <template slot="item" slot-scope="{ item }">
                    <div class="item">
                      <img :src="item.thumbnail" class="logo" />
                      <span class="item-name">{{ item.CommonName }}</span>
                    </div>
                  </template>-->
                </CoolSelect>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="not_muted standardizedWidth"
                      >Campaign Name</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    class="not_muted"
                    :class="{
                      validate_error:
                        $v.campaign.campaign_edit.campaign_name.$error
                    }"
                    v-model="campaign.campaign_edit.campaign_name"
                    placeholder="Required"
                    type="text"
                    id="campaign_name"
                    autocomplete="off"
                    :disabled="campaign.campaign_edit.CampaignTypeID < 1"
                    v-on:change.native="addDirtyField"
                    @input="$v.campaign.campaign_edit.campaign_name.$touch()"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="not_muted standardizedWidth"
                      >Investment</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    class="not_muted"
                    :class="{
                      validate_error:
                        $v.campaign.campaign_edit.custom_field_2.$error
                    }"
                    v-model="campaign.campaign_edit.custom_field_2"
                    placeholder="Required"
                    type="text"
                    id="custom_field_2"
                    autocomplete="off"
                    v-mask="'######'"
                    v-on:change.native="addDirtyField"
                    @input="$v.campaign.campaign_edit.custom_field_2.$touch()"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-4 mb-4">
            <b-col md="4">
              <b-form-group>
                <h4>From Date:</h4>
                <b-input-group>
                  <datepicker
                    id="ReportingStartDate"
                    :value="default_start_date"
                    :config="options"
                    @dp-change="change_from_date"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <h4>To Date:</h4>
                <b-input-group>
                  <datepicker
                    id="ReportingEndDate"
                    :value="default_end_date"
                    :config="options"
                    @dp-change="addDirtyField"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <div class="form-group form-actions" style="float:right;">
                <b-button
                  class="mr-2 mt-2"
                  size="md"
                  variant="outline-primary"
                  @click="back"
                >
                  <!-- <i class="fa fa-close"></i> -->
                  {{ CancelButtonVerbiage }}
                </b-button>
                <b-button
                  v-if="n_user.n_current_user.IsSU"
                  class="mr-0 mt-2"
                  size="md"
                  variant="primary"
                  type="submit"
                  :disabled="isClean"
                >
                  <i class="fa fa-save"></i>
                  Save
                </b-button>
              </div>

              <div class="form-group form-actions" style="float:right;">
                <b-alert
                  class="btn mr-4 mt-2"
                  :show="dismissCountDown"
                  fade
                  variant="light"
                  :dismissed="(dismissCountdown = 0)"
                  @dismiss-count-down="countDownChanged"
                >
                  Your information has been saved
                  <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
                </b-alert>
                <b-alert
                  class="btn mr-4 mt-2"
                  :show="dismiss2CountDown"
                  fade
                  variant="danger"
                  :dismissed="(dismiss2Countdown = 0)"
                  @dismiss-count-down="countDown2Changed"
                >
                  Your information could not be saved. Check all fields
                  carefully.
                  <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
                </b-alert>
                <b-alert
                  class="btn mr-4 mt-2"
                  :show="dismiss3CountDown"
                  fade
                  variant="danger"
                  :dismissed="(dismiss3Countdown = 0)"
                  @dismiss-count-down="countDown3Changed"
                >
                  PONumber already exists! Your information could not be saved.
                  <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
                </b-alert>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { required, email, minLength, helpers } from "vuelidate/lib/validators";
import { CoolSelect } from "vue-cool-select";
const alpha = helpers.regex("alpha", /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/);
import datepicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import moment from "moment";

export default {
  name: "CampaignProfile",
  data() {
    return {
      selected: [], // Must be an array reference!
      dirtyFields: [],
      show: true,
      seen: true,
      isSaving: false,
      isSaved: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      dismiss2Secs: 3,
      dismiss2CountDown: 0,
      dismiss3Secs: 3,
      selectedDealer: {},
      dismiss3CountDown: 0,
      showDismissibleAlert: false,
      default_start_date: moment()
        .add(1, "M")
        .startOf("month"),
      default_end_date: moment()
        .add(1, "M")
        .endOf("month"),

      options: {
        format: "MM/DD/YYYY",
        useCurrent: false
      }
    };
  },
  mounted() {
    //this.$store.state.campaign.campaign_edit.ReportingStartDate = this.default_start_date;
    //this.$store.state.campaign.campaign_edit.ReportingEndDate = this.default_end_date;
    if (this.$store.state.campaign.campaign_edit.CampaignStatID < 1) {
      this.addDirtyFieldWatch("ReportingStartDate", this.default_start_date);
      var _bd = new Date(this.default_start_date);
      this.addDirtyFieldWatch("broadcast_date", this.formatSIDate(_bd));
      this.addDirtyFieldWatch("ReportingEndDate", this.default_end_date);
    }
  },
  methods: {
    formatSIDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return year + "-" + month + "-" + day;
    },
    formatCampaignName() {
      var options = { year: "2-digit", month: "short" };
      var today = new Date(this.default_start_date);
      return (
        today.toLocaleDateString("en-US", options) +
        " " +
        this.selectedDealer.Name
      );

      //const year = date.getFullYear();
      //const month = String(date.getMonth() + 1).padStart(2, "0");
    },
    back() {
      this.$router.go(-1);
    },
    toggleVisibility() {
      this.seen = !this.seen;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    countDown2Changed(dismiss2CountDown) {
      this.dismiss2CountDown = dismiss2CountDown;
    },
    countDown3Changed(dismiss3CountDown) {
      this.dismiss3CountDown = dismiss3CountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },

    async save() {
      if (
        this.$store.state.campaign.campaigns.find(
          campaign =>
            campaign.PONumber ==
            this.$store.state.campaign.campaign_edit.PONumber
        )
      ) {
        this.dismiss3CountDown = this.dismiss3Secs;
        return;
      }

      //double check the database
      // if (this.$store.state.dealer.dealer_edit.UserProfileID === -1) {
      //   var _existing_id = -1;

      //   await this.$store
      //     .dispatch(
      //       "dealer/doesDealerExist",
      //       this.$store.state.dealer.dealer_edit.Name
      //     )
      //     .then(response => {
      //       _existing_id = response.data["DoesDealerExistResult"];
      //     });

      //   if (_existing_id > -1) {
      //     this.dismiss3CountDown = this.dismiss3Secs;
      //     return;
      //   }
      // }

      this.$v.$touch();
      if (this.$v.$error) {
        console.log(this.$v.$error);
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store.state.saveOp.localUrl = "/Campaign/Save/";
        this.$store.state.saveOp.localVariableName = "_c";
        this.$store.state.saveOp.localVariableObject = this.$store.state.campaign.campaign_edit;
        this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
        this.$store.state.saveOp.localFieldToSet = "CampaignStatID";
        this.$store.state.saveOp.localReturnObject = "SaveCampaignResult";

        console.log(this.dirtyFields);

        this.$store
          .dispatch("saveOp/BuildSaveOperation")
          .then(
            this.$store
              .dispatch("saveOp/EmitSave")
              .then(
                (this.dirtyFields = []),
                (this.dismissCountDown = this.dismissSecs),
                this.$store.state.saveOp.DestroySaveOperation
              )
          );

        // this.$store
        //   .dispatch("saveOp/BuildSaveOperation")
        //   .then(this.$store.dispatch.dispatch("saveOp/EmitSave"))
        //   .then(
        //     (this.dirtyFields = [])((this.dismissCountDown = this.dismissSecs))
        //   );
      }
    },
    addDirtyField: function(event) {
      if (event.which !== 9 && event.which !== 13) {
        this.dirtyFields = this.dirtyFields.filter(
          dirtyField => dirtyField.FieldName !== event.target.id
        );
        this.dirtyFields.push({
          FieldName: event.target.id,
          FieldValue: event.target.value
        });
      }
    },
    addDirtyFieldWatch: function(field, newValue) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== field
      );
      this.dirtyFields.push({
        FieldName: field,
        FieldValue: newValue
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldRadio: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.name
      );
      this.dirtyFields.push({
        FieldName: event.target.name,
        FieldValue: event.target.value
      });
      //console.log(this.$store.state.dealer.dealer_edit);
    },
    addDirtyFieldSwitch: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.checked.toString()
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },

    DashRouteTo(_page) {
      this.save();
      this.$router.push(_page);
    },
    change_from_date(event) {
      //   this.$store.state.campaign.campaign_edit.ReportingStartDate =
      //     event.target.value;
      this.addDirtyFieldWatch("ReportingStartDate", event.target.value);
      var _bd = new Date(event.target.value);
      this.addDirtyFieldWatch("broadcast_date", this.formatSIDate(_bd));
    },
    change_to_date(event) {
      //   this.$store.state.campaign.campaign_edit.ReportingEndDate =
      //     event.target.value;
      this.addDirtyFieldWatch("ReportingEndDate", event.target.value);
    }
  },
  computed: {
    ...mapState(["dealer", "campaign", "n_user", "saveOp"]),
    ...mapActions("saveOp", ["Save", "EmitSave"]),
    ...mapGetters("dealer", ["getDealerById"]),
    isClean() {
      return this.dirtyFields.length === 0;
    },

    CancelButtonVerbiage() {
      if (this.$store.state.n_user.n_current_user.IsSU) {
        return "Cancel";
      } else {
        return "Close";
      }
    }
  },
  components: {
    CoolSelect,
    datepicker,
    moment
  },
  validations: {
    campaign: {
      campaign_edit: {
        PONumber: {
          required
        },
        campaign_name: {
          required
        },
        custom_field_2: {
          required
        }
      }
    }
  },
  watch: {
    "$store.state.campaign.campaign_edit.DealershipID": function() {
      this.addDirtyFieldWatch(
        "DealershipID",
        this.$store.state.campaign.campaign_edit.DealershipID
      );
      if (this.$store.state.campaign.campaign_edit.DealershipID > 0) {
        this.selectedDealer = this.getDealerById(
          this.$store.state.campaign.campaign_edit.DealershipID
        );
      }
    },
    "$store.state.campaign.campaign_edit.CampaignTypeID": function() {
      this.addDirtyFieldWatch(
        "CampaignTypeID",
        this.$store.state.campaign.campaign_edit.CampaignTypeID
      );
      if (this.$store.state.campaign.campaign_edit.CampaignTypeID > 0) {
        this.$store.state.campaign.campaign_edit.campaign_name = this.formatCampaignName();
      }
    },
    "$store.state.campaign.campaign_edit.campaign_name": function() {
      this.addDirtyFieldWatch(
        "campaign_name",
        this.$store.state.campaign.campaign_edit.campaign_name
      );
    }
  }
};
</script>

<style lang="scss" scoped></style>
